export default "__VITE_ASSET__CDJ3Whzb__"